import React from 'react'
import InputWithLabel from './../../../../commons/InputWithLabel'

class EducationalLoan extends React.Component {
  onChange = (params) => {
    this.props.onChange(params)
  }

  render() {
    const {
      monthlyRepayment,
      outstandingBalance,
      owner,
      errors,
    } = this.props.commitment;

    return(
      <div className='card-body'>
        <InputWithLabel
          label="Monthly repayment"
          type='currency'
          defaultValue={ monthlyRepayment }
          errorMessage={ errors['monthlyRepayment'] }
          onChange={ (value) => { this.onChange({monthlyRepayment: value}) } }
        />
        <InputWithLabel
          label="Outstanding balance"
          type='currency'
          defaultValue={ outstandingBalance }
          errorMessage={ errors['outstandingBalance'] }
          onChange={ (value) => { this.onChange({outstandingBalance: value}) } }
        />
        {this.props.ownerOptions.length > 0 &&
          <InputWithLabel
            label='Owner'
            type='select'
            borderStyle='responsive'
            defaultValue={ owner }
            errorMessage={ errors['owner'] }
            options={ this.props.ownerOptions }
            onChange={ (value) => { this.onChange({owner: value}) } }
          />
        }
      </div>
    )
  }
}

export default EducationalLoan;
